module.exports = __webpack_public_path__ + "img/GoogleBusinessProfile.e72cc068.svg";